import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import AuthorizedTenantElement from "@/common/components/Auth/AuthorizedTenantElement";
import VehicleOperations from "@/common/components/EntityComposed/Operations/VehicleOperations";
import { ViewVariant } from "@/common/ts/layout";
import { VehicleDto } from "@/core/api/generated/v1";

interface Props {
  vehicle: VehicleDto;
}

export default function OperationsTabContent({ vehicle }: Props) {
  return (
    <PageTabContent>
      <AuthorizedTenantElement tenantIdsAny={[vehicle?.tenantId, vehicle?.ownerTenantId]} withAlert>
        <VehicleOperations
          vehicleId={vehicle.id}
          displayProps={{ viewVariant: ViewVariant.Tab, header: false }}
        />
      </AuthorizedTenantElement>
    </PageTabContent>
  );
}
